import * as v from 'valibot';

export const tabValues = ['funding', 'languages', 'basic', 'info', 'multimedia'] as const;

export const projectDetailSearchSchema = v.object({
	tab: v.fallback(v.optional(v.picklist(tabValues)), undefined),
	editing: v.fallback(v.optional(v.boolean()), undefined),
	plang: v.fallback(v.optional(v.string()), undefined),
	addToPortal: v.fallback(v.optional(v.boolean()), undefined),
	fromPortal: v.fallback(v.optional(v.string()), undefined),
});
